import { PICTREE } from "../../constants";

const initialState = {
  loading: false,
  selectedSeasonId: "cmrz0wo8t0000bpzcana86bow",
  selectedSeasonIds: ["cmrz0wo8t0000bpzcana86bow"],
  selectedBoostEventId: "__ALL__",
  selectedDateRange: [null, null],
  selectedCompanyCode: "NTT_ME",
  seasonOptions: [
    // { value: "cmn8t73ia0001jmpr4eig3uah", label: "千葉シーズン" },
    { value: "cmrz0wo8t0000bpzcana86bow", label: "レギュラーシーズン2" },
  ],
  companyOptions: [
    { value: "NTT_ME", label: "NTT ME", active: true },
    { value: "TEPCO", label: "東京電力 TEPCO", active: false },
    { value: "NTT_FT", label: "NTT FT", active: false },
  ],
  kpis: [],
  trend: {
    date: [],
    uniqueShots: [],
    reviewerOk: [],
    uniqueShooters: [],
  },
  trendLoading: false,
  trendRows: [],
  trendRowsLoading: false,
  seasonChartLoading: false,
  seasonChart: {
    labels: [],
    series: [],
  },
  bootstrapEventLoading: false,
  bootstrapEventReady: false,
  eventRowsLoading: false,
  eventRows: [],
  areaSummary: null,
  areaTable: [],
  areaLoading: false,
  areaError: null,
  areaRequestKey: null,
};

export default function pictreeRegularSeasonEventReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_REGULAR_SEASON_EVENT_PAGE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case PICTREE.SET_REGULAR_SEASON_EVENT_PAGE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case PICTREE.SET_REGULAR_SEASON_EVENT_AREA_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
